export default {

  namespaced: true,

  state: () => ({

    accounCashFlowResume: {}

  }),

  mutations: {
    setCashFlowResume(state, data) {

      state.accounCashFlowResume = data;

    }

  },

  actions: {

    async getCashFlowResume({ dispatch, commit }, params) {

      const data = await axios.get("/erp/account/cashflow", params);

      return data;
    }

  }
}
